import { Dictionaries } from "gql/graphql";
import { ReactNode } from "react";
import { generatePath } from "react-router-dom";
import { DICTIONARY_VALUE_CREATE_PATH } from "./dictionary-create-value-path";
import { AddButton } from "@/shared/form/button";

export function ToDictionaryCreateValue({
  children,
  dictionary,
}: {
  children: ReactNode;
  dictionary: Dictionaries;
}) {
  return (
    <AddButton
      accent={false}
      type="link"
      target="_blank"
      href={generatePath(DICTIONARY_VALUE_CREATE_PATH, {
        dictionary,
      })}
    >
      {children}
    </AddButton>
  );
}
